import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { STEPS, STEP_INDEX, fmtDate } from "@/lib/ops";
import { num, useApi } from "@/lib/api";

export const TransactionsList = () => {
  const api = useApi();
  const [txs, setTxs] = useState(null);
  useEffect(() => {
    api("get", "/transactions").then((r) => setTxs(r.data)).catch(() => setTxs([]));
  }, [api]);
  if (!txs) return null;
  if (!txs.length) return <p className="text-center py-16 bg-white rounded-2xl border border-dashed border-slate-300 text-slate-600" data-testid="empty-transactions">Aún no tienes transacciones. Se crean al adjudicar un lote o ganar una subasta.</p>;
  return (
    <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100" data-testid="transactions-list">
      {txs.map((t) => (
        <Link key={t.id} to={`/transacciones/${t.id}`} className="flex flex-wrap items-center justify-between gap-3 p-4 hover:bg-[#f4f7f6] transition-colors" data-testid={`transaction-row-${t.id}`}>
          <div>
            <p className="font-medium text-[#05130e]">{t.lot.title}</p>
            <p className="text-xs text-slate-500 font-mono">{t.code} · {t.role === "generador" ? "Generador" : "Receptor"} · {num(t.lot.weight_tons, 2)} t · {fmtDate(t.created_at)}</p>
          </div>
          <span className="flex items-center gap-3 text-sm">
            <span className={`text-xs px-2.5 py-1 rounded-full ${t.status === "cerrada" ? "bg-[#00f2a1]/20 text-[#007a50]" : "bg-amber-50 text-amber-700"}`}>{STEPS[STEP_INDEX[t.status]].label}</span>
            <ArrowRight className="w-4 h-4 text-slate-400" />
          </span>
        </Link>
      ))}
    </div>
  );
};
